import { render } from "./registeritem.vue?vue&type=template&id=1bea1f4e&scoped=true"
import script from "./registeritem.vue?vue&type=script&lang=js"
export * from "./registeritem.vue?vue&type=script&lang=js"

import "./registeritem.vue?vue&type=style&index=0&id=1bea1f4e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1bea1f4e"

export default script